import { LABELS } from "~/resources/Labels";
import { TableHeaderType } from "./types/TableHeaderType";


export const OutPutTemplateHeader: TableHeaderType[] = [
    {
      label: LABELS.Name,
      key: 'name',
      id: 'name',
      sortable: true,
    },
        {
      label: "CloudProviders",
      key: 'cloudProvider',
      id: 'cloudProvider',
      sortable: true,
    },
    {
      label: "ScriptType",
      key: 'scriptType',
      id: 'scriptType',
      sortable: true,
    },
    {
      id: 'dateAdded',
      label: 'DateAdded',
      alignment: '',
      sortable: true,
      key: 'dateAdded',
    },

    {
      id: 'actions',
      label:'',
      alignment: '',
      sortable: false,
      key: '',
    },
  ];
